var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id, validationId) {
      pug_mixins["input"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.type) {
attributes.type = 'text'
}
if (!attributes.attributes) {
attributes.attributes = {}
}
if (!attributes.groupAttributes) {
attributes.groupAttributes = {}
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key
}
pug_html = pug_html + "\u003Cdiv" + (pug.attrs(pug.merge([{"class": pug.classes(["form-group",attributes.groupHtmlClass], [false,false])},attributes.groupAttributes]), true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (pug.attr("class", pug.classes(["control-label",attributes.labelHtmlClass], [false,true]), false, true)+pug.attr("for", id, true, true)) + "\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Flabel\u003E";
}
if (attributes.divTitle) {
pug_html = pug_html + "\u003Cdiv" + (pug.attr("class", pug.classes(["control-label",attributes.divTitleHtmlClass], [false,true]), false, true)) + "\u003E" + (null == (pug_interp = attributes.divTitle) ? "" : pug_interp) + "\u003C\u002Fdiv\u003E";
}
pug_html = pug_html + "\u003Cinput" + (pug.attrs(pug.merge([{"class": pug.classes(["form-control",attributes.fieldHtmlClass], [false,true]),"id": pug.escape(id),"type": pug.escape(attributes.type),"placeholder": pug.escape(attributes.placeholder),"ng-model": pug.escape(attributes.key),"ng-disabled": pug.escape(attributes.readonly),"name": pug.escape(id),"value": pug.escape(attributes.value),"required": pug.escape(attributes.required),"ng-pattern": pug.escape(attributes['ng-pattern']),"disabled": pug.escape(attributes.disabled),"data-cy": pug.escape(attributes['data-cy'])},attributes.attributes]), true)) + "\u003E";
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (attributes.validationMessages) {
validationId = '"'+ id +'"'
if (attributes.validationId) {
validationId = attributes.validationId
}
pug_mixins["validationMessages"].call({
attributes: {"key": pug.escape(validationId),"validationMessages": pug.escape(attributes.validationMessages)}
});
}
block && block();
pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};



















































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};





























































pug_mixins["form"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (attributes.name) {
globals.formname = attributes.name
}
pug_html = pug_html + "\u003Cform" + (pug.attrs(pug.merge([{"novalidate": pug.escape(true)},attributes]), true)) + "\u003E";
block && block();
pug_html = pug_html + "\u003C\u002Fform\u003E";
};
pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv ng-if=\"!mpp.is_special_customer\"\u003E\u003Cdiv class=\"box\" id=\"currentFinances\" ng-class=\"{ open : mobileOpen }\" sidebar-scroll overlay=\"mpp.loading\"\u003E\u003Cdiv class=\"title\" ng-click=\"mobileOpen = !mobileOpen\"\u003E\u003Ci class=\"font-icon icon-{{ mobileOpen ? &quot;down&quot; : &quot;up&quot; }}\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EWarenkorb\u003Cspan ng-if=\"!alternateUser\"\u003E- {{ employeeId}}\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"mobile\"\u003EUmwandlungsrate:\u003C\u002Fspan\u003E\u003Cspan class=\"mobile plus\" ng-if=\"!mpp.is_bonus\"\u003E{{ mpp.leasing | currency }}\u003C\u002Fspan\u003E\u003Cspan class=\"mobile plus\" ng-if=\"mpp.is_bonus &amp;&amp; mpp.bonus_checkout_config\"\u003E{{ mpp.getPerMonthValue() | currency }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" overlay=\"mppCart\"\u003E\u003Cdiv class=\"div\" ng-if=\"mpp.is_bonus\"\u003E\u003Cdiv class=\"div\" ng-if=\"mpp.is_overspending_allowed &amp;&amp; !mpp.is_leader\"\u003E\u003Cdiv class=\"center\"\u003ESie können entscheiden, ob die Wahlleistung über Ihr Budget oder durch Entgeltumwandlung abgebildet werden soll.\u003C\u002Fdiv\u003E\u003Cdiv class=\"form-group\"\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Cinput type=\"checkbox\" data-cy=\"mpp.preCheckout.common.sideMenu.budgetFinancing\" ng-model=\"mpp.models.isPaymentMethodBudget\" ng-change=\"mpp.handleBonusPaymentMethodChange(&quot;budget&quot;)\" id=\"checkbox_payment_budget\"\u003E\u003Clabel for=\"checkbox_payment_budget\"\u003E\u003Cspan\u003EBudget\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"checkbox\"\u003E\u003Cinput type=\"checkbox\" ng-model=\"mpp.models.isPaymentMethodExchange\" ng-change=\"mpp.handleBonusPaymentMethodChange(&quot;exchange&quot;)\" id=\"checkbox_payment_exchange\"\u003E\u003Clabel for=\"checkbox_payment_exchange\"\u003E\u003Cspan\u003EEntgeltumwandlung\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"center\"\u003E\u003Cbutton class=\"button button-primary expand\" overlay=\"cartSave\" ng-click=\"mpp.completeCheckout()\" ng-show=\"mpp.canShop\" ng-disabled=\"!mpp.canCheckout() || mppSide.is_vacation\" data-cy=\"mpp.preCheckout.common.sideMenu.buttonStartCheckout\"\u003E{{ mpp.neo_component ? 'Zur Beantragung' : 'Warenkorb übernehmen' }}\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cul ng-if=\"!mpp.cart.articles.length &amp;&amp; !mpp.basket.articles.length\"\u003E\u003Cli\u003E\u003Cspan\u003EKeine Produkte im Warenkorb\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cul ng-if=\"mpp.cart.articles.length || mpp.basket.articles.length\"\u003E\u003Cli class=\"blue has-dropdown\" ng-repeat=\"article in mpp.cart.articles || mpp.basket.articles\" ng-class=\"{red: article.error}\"\u003E\u003Ca ng-click=\"article.open = !article.open\" ng-class=\"{ openable: true, selected: article.open }\"\u003E\u003Cspan class=\"key light\"\u003E\u003Cspan ng-if=\"article.quantity &gt; 1 &amp;&amp; article.name\"\u003E{{ article.quantity }} x&nbsp;\u003C\u002Fspan\u003E\u003Cspan\u003E{{ article.name ? article.name : article.Artikelnummer }}\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ article.price * article.quantity | currency }}\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Cul class=\"submenu\" ng-show=\"article.open\"\u003E\u003Cli class=\"row\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["input"].call({
attributes: {"key": "article.quantity","title": "Anzahl","type": "number","required": pug.escape(true),"id": "quantity{{$index}}","validationId": "'quantity' + $index","validationMessages": {"required":"Bitte geben sie einen postiven Wert an"},"readonly": "!mpp.canShop","attributes": {"ng-change":"mpp.setArticleOnCart(article, article.quantity)"}}
});
},
attributes: {"class": "cart right","name": "cartForm","id": "cartForm{{$index}}"}
});
pug_html = pug_html + "\u003Cspan class=\"cart left\"\u003E\u003Ci class=\"font-icon icon-info\" ng-click=\"mppSide.goTo(article)\" ng-show=\"article.open\" ng-class=\"{orange: article.error}\"\u003E\u003C\u002Fi\u003E\u003Cspan ng-hide=\"!mpp.canShop\"\u003E\u003Ci class=\"font-icon icon-delete\" ng-click=\"mpp.removeArticle($index)\" ng-show=\"article.open\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fli\u003E\u003Cli class=\"blue\"\u003E\u003Cspan class=\"key light\"\u003EHandling fee\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.get_brutto_handling_fee()  | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cul\u003E\u003Cli\u003E\u003Cspan class=\"key bold\"\u003EGesamtwert:\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.getTotalSum() | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"blue\" ng-if=\"!mpp.is_bonus\" ng-class=\"{'last' : !mpp.is_bonus}\"\u003E\u003Cspan class=\"key light\"\u003EEntgeltumwandlung\u003C\u002Fspan\u003E\u003Cspan class=\"value\" ng-if=\"mpp.getTotalSum()&gt;0\"\u003E{{ mpp.leasing | currency }}\u003C\u002Fspan\u003E\u003Cspan class=\"value\" ng-if=\"mpp.getTotalSum()==0\"\u003E{{ 0 | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"blue\" ng-if=\"mpp.is_bonus\"\u003E\u003Cspan class=\"key light\"\u003EMaximalwert Warenkorb über Budget\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.bonus_limits.max_brutto_value | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"blue\" ng-if=\"mpp.is_bonus &amp;&amp; mpp.bonus_checkout_config\"\u003E\u003Cspan class=\"key light\"\u003Emonatliche Rate\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.getPerMonthValue()  | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cdiv class=\"center\"\u003E\u003Cp class=\"strong red\" ng-if=\"mppSide.is_vacation\"\u003EVom 02.04. bis einschließlich 05.04. sind Bestellungen auf Grund der Osterfeiertage nicht möglich - Wir wünschen Frohe Ostern.\u003C\u002Fp\u003E\u003Cp ng-if=\"mpp.calculate_remaining_brutto_to_min() &gt; 0\"\u003EZum Erreichen des Mindestbestellwerts fehlen noch {{ mpp.calculate_remaining_brutto_to_min() | currency }}.\u003C\u002Fp\u003E\u003Cp ng-if=\"!mpp.isValidCart\"\u003ELeider fehlt noch ein gültiger Hauptartikel für ihre Bestellung.\u003C\u002Fp\u003E\u003Cp ng-if=\"mpp.errors\"\u003ELeider ist einer Ihrer gewählten Artikel (zur Zeit) nicht mehr verfügbar.\u003C\u002Fp\u003E\u003Cp ng-if=\"mpp.budget_not_enough &amp;&amp; !mpp.is_overspending_allowed\"\u003EIhr Warenkorb übersteigt das verfügbare Budget {{ mpp.bonus_limits.max_brutto_value | currency: 'EUR' }} für die Vertragslaufzeit. Bitte ändern Sie Ihren Warenkorb ab.\u003C\u002Fp\u003E\u003Cp class=\"red\" ng-if=\"mpp.bonus_start_date_after_bonus_project_end_date\"\u003EDiese Wahlleistung steht in diesem Projekt aktuell nicht zur Verfügung.\u003C\u002Fp\u003E\u003Cp ng-if=\"!mpp.hasBoniNr()\"\u003EDer Abruf von PC-Leasing ist aktuell noch nicht aktiviert\u003C\u002Fp\u003E\u003Cp ng-if=\"!mpp.canShop\"\u003ELeider ist derzeit eine Beantragung nicht möglich\u003C\u002Fp\u003E\u003Cp class=\"strong red\" ng-if=\"mpp.hasUnfinishedBuyingProcess\"\u003EEs liegt eine offene Rechnung vor, bis zur Begleichung ist kein neuer Checkout möglich.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"center buttons\" ng-if=\"mpp.getTotalSum()&gt;0\"\u003E\u003Cp ng-if=\"mpp.neo_component\"\u003EErmitteln Sie Ihren Vorteil anhand Ihrer angegebenen Entgeltdaten\u003C\u002Fp\u003E\u003Cbutton class=\"button button-primary expand\" ng-click=\"mpp.calcAdvantage()\" ng-if=\"!mpp.is_bonus\"\u003EVorteil berechnen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cul class=\"vorteil\" ng-show=\"mpp.showAdvantage\"\u003E\u003Cli\u003EVorteilsberechnung über 24 Monate\u003C\u002Fli\u003E\u003Cli ng-if=\"!mpp.is_bonus\" ng-class=\"{'last' : !mpp.is_bonus}\"\u003E\u003Cspan class=\"key\"\u003EBruttoumwandlung:\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.leasing | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli ng-if=\"mpp.is_bonus &amp;&amp; mpp.bonus_checkout_config\"\u003E\u003Cspan class=\"key\"\u003EBruttoumwandlung:\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.leasing | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"key\"\u003Emtl. Nettobelastung:\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.totalNettoInvest\u002F24 | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"key\"\u003EAufwand Laufzeit:\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.totalNettoInvest | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"key\"\u003Emgl. Endkaufpreis:\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.lastPayment | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"key bold\"\u003EGesamtkosten:\u003C\u002Fspan\u003E\u003Cspan class=\"value bold\"\u003E{{ mpp.totalExpense | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"key\"\u003Eeffektive Monatsrate:\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.totalExpense \u002F24 | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"key\"\u003EDirektkauf:\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.getTotalSum() | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"key\"\u003EUnterschied EUR:\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.getTotalSum() - mpp.totalExpense | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli\u003E\u003Cspan class=\"key bold\"\u003EUnterschied %:\u003C\u002Fspan\u003E\u003Cspan class=\"value bold\"\u003E{{ mpp.advPercent | number:2 }} %\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cp class=\"small\" ng-show=\"mpp.showAdvantage\"\u003EDie Gesamtkosten setzen sich aus der mtl. Nettobelastung über 24 Monate und einem angenommenen Endkaufpreis von aktuell {{ mpp.endprice_percentage * 100 | number }} % des Neuwerts zusammen.\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv ng-if=\"mpp.is_special_customer\"\u003E\u003Cdiv class=\"box\" id=\"currentFinances\" ng-class=\"{ open : mobileOpen }\" sidebar-scroll overlay=\"mpp.loading\"\u003E\u003Cdiv class=\"title\" ng-click=\"mobileOpen = !mobileOpen\"\u003E\u003Ci class=\"font-icon icon-{{ mobileOpen ? &quot;down&quot; : &quot;up&quot; }}\"\u003E\u003C\u002Fi\u003E\u003Cspan\u003EWarenkorb\u003Cspan ng-if=\"!alternateUser\"\u003E- {{ employeeId}}\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"mobile\"\u003EGesamt:\u003C\u002Fspan\u003E\u003Cspan class=\"mobile plus\" ng-if=\"!mpp.is_bonus\"\u003E{{ mpp.leasing | currency }}\u003C\u002Fspan\u003E\u003Cspan class=\"mobile plus\" ng-if=\"mpp.is_bonus &amp;&amp; mpp.bonus_checkout_config\"\u003E{{ mpp.getPerMonthValue() | currency }}\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"main\" overlay=\"mppCart\"\u003E\u003Cdiv class=\"center\"\u003E\u003Cbutton class=\"button button-primary expand\" overlay=\"cartSave\" ng-click=\"mpp.completeCheckout()\" ng-show=\"mpp.canShop\" ng-disabled=\"!mpp.canCheckout() || mppSide.is_vacation\" data-cy=\"mpp.preCheckout.common.sideMenu.buttonStartCheckout\"\u003EZur Bestellung\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003Cul ng-if=\"!mpp.cart.articles.length &amp;&amp; !mpp.basket.articles.length\"\u003E\u003Cli\u003E\u003Cspan\u003EKeine Produkte im Warenkorb\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cul ng-if=\"mpp.cart.articles.length || mpp.basket.articles.length\"\u003E\u003Cli class=\"blue has-dropdown\" ng-repeat=\"article in mpp.cart.articles || mpp.basket.articles\" ng-class=\"{red: article.error}\"\u003E\u003Ca ng-click=\"article.open = !article.open\" ng-class=\"{ openable: true, selected: article.open }\"\u003E\u003Cspan class=\"key light\"\u003E\u003Cspan ng-if=\"article.quantity &gt; 1 &amp;&amp; article.name\"\u003E{{ article.quantity }} x&nbsp;\u003C\u002Fspan\u003E\u003Cspan\u003E{{ article.name ? article.name : article.Artikelnummer }}\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ article.price * article.quantity | currency }}\u003C\u002Fspan\u003E\u003C\u002Fa\u003E\u003Cul class=\"submenu\" ng-show=\"article.open\"\u003E\u003Cli class=\"row\"\u003E";
globals = {}
pug_mixins["form"].call({
block: function(){
pug_mixins["input"].call({
attributes: {"key": "article.quantity","title": "Anzahl","type": "number","required": pug.escape(true),"id": "quantity{{$index}}","validationId": "'quantity' + $index","validationMessages": {"required":"Bitte geben sie einen postiven Wert an"},"readonly": "!mpp.canShop","attributes": {"ng-change":"mpp.setArticleOnCart(article, article.quantity)"}}
});
},
attributes: {"class": "cart right","name": "cartForm","id": "cartForm{{$index}}"}
});
pug_html = pug_html + "\u003Cspan class=\"cart left\"\u003E\u003Ci class=\"font-icon icon-info\" ng-click=\"mppSide.goTo(article)\" ng-show=\"article.open\" ng-class=\"{orange: article.error}\"\u003E\u003C\u002Fi\u003E\u003Cspan ng-hide=\"!mpp.canShop\"\u003E\u003Ci class=\"font-icon icon-delete\" ng-click=\"mpp.removeArticle($index)\" ng-show=\"article.open\"\u003E\u003C\u002Fi\u003E\u003C\u002Fspan\u003E\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003C\u002Fli\u003E\u003Cli class=\"blue\"\u003E\u003Cspan class=\"key light\"\u003EHandling fee\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.get_brutto_handling_fee()  | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cul\u003E\u003Cli\u003E\u003Cspan class=\"key bold\"\u003EGesamtwert:\u003C\u002Fspan\u003E\u003Cspan class=\"value\"\u003E{{ mpp.getTotalSum() | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003Cli class=\"blue\" ng-if=\"!mpp.is_bonus\" ng-class=\"{'last' : !mpp.is_bonus}\"\u003E\u003Cspan class=\"key light\"\u003EBudgetbedarf\u003C\u002Fspan\u003E\u003Cspan class=\"value\" ng-if=\"mpp.getTotalSum()&gt;0\"\u003E{{ mpp.leasing | currency }}\u003C\u002Fspan\u003E\u003Cspan class=\"value\" ng-if=\"mpp.getTotalSum()==0\"\u003E{{ 0 | currency }}\u003C\u002Fspan\u003E\u003C\u002Fli\u003E\u003C\u002Ful\u003E\u003Cdiv class=\"center\"\u003E\u003Cp class=\"strong red\" ng-if=\"mppSide.is_vacation\"\u003EVom 02.04. bis einschließlich 05.04. sind Bestellungen auf Grund der Osterfeiertage nicht möglich - Wir wünschen Frohe Ostern.\u003C\u002Fp\u003E\u003Cp ng-if=\"mpp.calculate_remaining_brutto_to_min() &gt; 0\"\u003EZum Erreichen des Mindestbestellwerts fehlen noch {{ mpp.calculate_remaining_brutto_to_min() | currency }}.\u003C\u002Fp\u003E\u003Cp ng-if=\"mpp.errors\"\u003ELeider ist einer Ihrer gewählten Artikel (zur Zeit) nicht mehr verfügbar.\u003C\u002Fp\u003E\u003Cp ng-if=\"!mpp.hasBoniNr()\"\u003EDer Abruf von PC-Leasing ist aktuell noch nicht aktiviert\u003C\u002Fp\u003E\u003Cp ng-if=\"!mpp.canShop\"\u003ELeider ist derzeit eine Beantragung nicht möglich\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined, "validationId" in locals_for_with ?
        locals_for_with.validationId :
        typeof validationId !== 'undefined' ? validationId : undefined));
    ;;return pug_html;};
module.exports = template;